/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import Main from '../../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../../../store/slices/hook/useApiRequest';
import Button from '../../../../components/common/Button';
import CustomTable from '../../../../components/common/CustomTable';
import { clearTeamMemberData, deleteTeamMember, fetchTeamMember, selectTeamMemberData, setTeamMemberData } from '../../../../store/slices/api/inner/TeamMemberSlice';
import { selectSelectedTeamMemberMember, setSelectedTeamMember, toggleCommonDeleteModal } from '../../../../store/slices/common';
import { FaPlus } from 'react-icons/fa';
import TableAction from '../../../../components/TableAction';
import { NAVIGATION } from '../../../../lib/navigation';
import { useNavigate } from 'react-router-dom';



export const TeamMemberPage = () => {
  const dispatch = useDispatch();
  const teamMemberData = useSelector(selectTeamMemberData);
  const selectedTeamMember = useSelector(selectSelectedTeamMemberMember)
  const navigate = useNavigate();

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchTeamMember,
    setValueAction: setTeamMemberData,
    clearValueActionOnError: clearTeamMemberData,
    isForm: false,
    successMessage: false,
  });

  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedTeamMember(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedTeamMember(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteTeamMember,
    isForm: false,
    afterAPICall,
  });
  // delete end

  const handleEdit = (data) => {
    navigate(NAVIGATION.INNER_NAVIGATION.MASTERS.UPDATE_TEAM_MEMBERS, { state: { teamMemberData: data } });
  };

  const handleAdd = () => {
    dispatch(setSelectedTeamMember(null));
    navigate(NAVIGATION.INNER_NAVIGATION.MASTERS.ADD_TEAM_MEMBERS)
  }
  

  const columns = useMemo(() => [

    {
      accessorKey: 'team_member_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"team member name"
    },
    {
      accessorKey: 'team_member_designation',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"designation"
    },
    {
      accessorKey: 'profile_image',
     
      cell: info =>  <div className='h-24 w-28 flex items-center justify-center'>
      <img src={`${process.env.REACT_APP_BASE_URL}/assets/${info.getValue()}`} className='rounded' alt='profile' />
      </div>,
    },
    {
      accessorKey: 'twitter_url',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"twitter url"
    },
    {
      accessorKey: 'linkedIn_url',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
       header:"linkedin url"
    },
    {
      accessorKey: 'facebook_url',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
       header:"facebook url"
    },
    {
      accessorKey: 'instagram_url',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
       header:"facebook url"
    },
    {
      id: 'actions',

      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, { title: "team members" }]} handleDelete={() => {handleDelete({ teamMemberId: selectedTeamMember.team_member_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={teamMemberData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add team member</Button>} />
    </Main>
  );
};
